/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MilkAndDerivativesExecuteAliases {
  ACCORDION_INFORMATION = 'accordion-information',
  ACCORDION_OTHER_INFORMATION = 'accordion-other-information',
  ADMINISTRATION_BY_PROCESS_CARD = 'administration-by-process-card',
  BARCODE_MILK_AND_DERIVATIVES = 'barcode-milk-and-derivatives',
  BUTTON_EXECUTE = 'button-execute',
  CONTENT_INFORMATION_HEADER = 'content-information-header',
  DATE_HOUR_FIELD = 'date-hour-field',
  DATE_HOUR_INPUT = 'date-hour-input',
  DILUTION_FIELD = 'dilution-field',
  DILUTION_TEXT_AREA = 'dilution-text-area',
  GLOBAL_ACTIONS_EXECUTE = 'global-actions-execute',
  INFORMATION_FORM = 'information-form',
  INFORMATION_TEXT = 'information-text',
  JUSTIFICATION_FIELD = 'justification-field',
  JUSTIFICATION_TEXT_AREA = 'justification-text-area',
  MILK_AND_DERIVATIVES_EXECUTE_LAYOUT = 'milk-and-derivatives-execute-layout',
  MILK_AND_DERIVATIVES_INFORMATION_DECK = 'milk-and-derivatives-information-deck',
  MILK_AND_DERIVATIVES_LEGENDS = 'milk-and-derivatives-legends',
  MORE_INFORMATION_TEXT = 'more-information-text',
  OBSERVATION_FIELD = 'observation-field',
  OBSERVATION_TEXT_AREA = 'observation-text-area',
  PANEL_ACCORDION_INFORMATION = 'panel-accordion-information',
  PANEL_ACCORDION_OTHER_INFORMATION = 'panel-accordion-other-information',
  PANEL_BARCODE = 'panel-barcode',
  PANEL_DECK_MORE_INFORMATION = 'panel-deck-more-information',
  PANEL_FORM_INFORMATION = 'panel-form-information',
  PANEL_INFORMATION_HEADER = 'panel-information-header',
  PANEL_MORE_INFORMATION_TEXT = 'panel-more-information-text',
  PRESCRIPTION_VOLUME_FIELD = 'prescription-volume-field',
  PRESCRIPTION_VOLUME_INPUT = 'prescription-volume-input',
  TEXT_MEDICATION_DATE = 'text-medication-date',
  TEXT_MEDICATION_INFORMATION = 'text-medication-information',
  VOLUME_EXECUTED_FIELD = 'volume-executed-field',
  VOLUME_EXECUTED_INPUT = 'volume-executed-input',
}
export { MilkAndDerivativesExecuteAliases };
